/**
 * Expense description helper.
 *
 * `expenses.description` is a legacy `varchar(255) NOT NULL` column with no
 * default. Newer forms never ask for it, so every insert path must derive one
 * or the insert fails with 23502 (#587). Shared by the shared data op and the
 * web API layer so both write the same value.
 */

export const EXPENSE_DESCRIPTION_MAX_LENGTH = 255

const firstNonBlank = (...values) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim()
  }
  return null
}

/**
 * Derive a non-empty `description` for an expense insert.
 * Order: explicit description → notes → billable description → vendor →
 * category name → 'Expense'. Truncated to the column width.
 *
 * @param {Object} expense
 * @returns {string}
 */
export const buildExpenseDescription = (expense = {}) => {
  const value =
    firstNonBlank(
      expense?.description,
      expense?.notes,
      expense?.billable_description,
      expense?.vendor,
      expense?.category_name,
    ) || 'Expense'
  return value.slice(0, EXPENSE_DESCRIPTION_MAX_LENGTH)
}
